const NETWORKS = {
  BSC: "BSC",
  ETH: "ETH",
  SOL: "SOL",
  TRX: "TRX",
  CHZ: "CHZ",
  MATIC: "MATIC",
  CRO: "CRO",
  EGLD: "EGLD",
  NEAR: "NEAR",
  KLAY: "KLAY",
  ARBITRUM: "ARBITRUM",
  ARBITRUM_NOVA: "ARBITRUM_NOVA",
  AVAX_C: "AVAX_C",
  AVAX_X: "AVAX_X",
  HECO: "HECO",
  RUNE: "RUNE",
  XLM: "XLM",
  XMR: "XMR",
  ADA: "ADA",
  XRP: "XRP",
  OPTIMISM: "OPTIMISM",
  ZIL: "ZIL",
  QIE: "QIE",
  DOT: "DOT",
  WAVES: "WAVES",
  FTM: "FTM",
  ALGO: "ALGO",
  TAO: "TAO",
  BTC: "BTC",
  XDC: "XDC",
  TON: "TON",
  ONTOLOGY: "ONTOLOGY",
  BIZA: "BIZA",
  METIS: "METIS",
  ACA: "ACA",
  FLR: "FLR",
  FLOW: "FLOW",
  ONE: "ONE",
  LTC: "LTC",
  NRK: "NRK",
  TLOS: "TLOS",
  AKT: "AKT",
  GLMR: "GLMR",
  GMMT: "GMMT",
  DAG: "DAG",
  XPR: "XPR",
  APTOS: "APTOS",
  ASTAR: "ASTAR",
  ATOM: "ATOM",
  DASH: "DASH",
  FIL: "FIL",
  ICX: "ICX",
  INTR: "INTR",
  ICP: "ICP",
  KSM: "KSM",
  MOVR: "MOVR",
  KHALA: "Khala",
  QTUM: "QTUM",
  STX: "STX",
  XTZ: "XTZ",
  ZEC: "ZEC",
  KAS: "KAS",
  MINA: "MINA",
  XANA: "XANA",
  FRA: "FRA",
  BASE: "BASE",
  PLAYA3ULL: "PLAYA3ULL",
  OSMO: "OSMO",
  CSPR: "CSPR",
  WEMIX: "WEMIX",
  SC: "SC",
  XCH: "XCH",
  DCR: "DCR",
  NANO: "NANO",
  RON: "RON",
  VET: "VET",
  EVER: "EVER",
  KDA: "KDA",
  LSK: "LSK",
  LUNC: "LUNC",
  SATOX: "SATOX",
  LYX: "LYX",
  POLYX: "POLYX",
  ZETA: "ZETA",
  HBAR: "HBAR",
  CKB: "CKB",
  MXC: "MXC",
  MANTA: "MANTA",
  CFX: "CFX",
  CFXeSpace: "CFXeSpace",
  zkSyncEra: "zkSyncEra",
  EvaChain: "EvaChain",
  AR: "AR",
  Starknet: "Starknet",
  ROSE: "ROSE",
  COREUM: "COREUM",
  BLAST: "BLAST",
  ALPH: "ALPH",
  DOGE: "DOGE",
  MERLIN: "MERLIN",
  MODE: "MODE",
  LINEA: "LINEA",
  BounceBit: "BounceBit",
  ENJ: "ENJ",
  MANTLE: "MANTLE",
  INJ: "INJ",
  SYS: "SYS",
  SYSNEVM: "SYSNEVM",
  NTRN: "NTRN",
  TIA: "TIA",
  NEO: "NEO",
  NEON3: "NEON3",
  QUBIC: "QUBIC",
  VENOM: "VENOM",
  MTRG: "MTRG",
  SUI: "SUI",
  CORE: "CORE",
  DIVI: "DIVI",
  KAVA: "KAVA",
  BAHAMUT: "BAHAMUT",
  IRON: "IRON",
  PSL: "PSL",
  OMN: "OMN",
  KLS: "KLS",
  DYM: "DYM",
  DIS: "DIS",
  SXP: "SXP",
  OMAX: "OMAX",
  RVN: "RVN",
  JOYSTREAM: "JOYSTREAM",
  KLV: "KLV",
  KUB: "KUB",
  OKT: "OKT",
  IOST: "IOST",
  IOTX: "IOTX",
  IOTA: "IOTA",
  XEM: "XEM",
  RXD: "RXD",
  WAXP: "WAXP",
  AVAIL: "AVAIL",
  SEI: "SEI",
  DC: "DC",
  MTC: "MTC",
  FRACTAL: "FRACTAL",
  ETHW: "ETHW",
  KUJI: "KUJI",
  SAGA: "SAGA",
  BCH: "BCH",
  BSV: "BSV",
  SCR: "SCR",
  KRO: "KRO",
};

const BSC = [
  "bsc",
  "BSC",
  "BEP20(BSC)",
  "BEP20 (BSC)",
  "BEP20",
  "bep20",
  "BNB Smart Chain",
  "BSC(BEP20)",
  "BNB Smart Chain(BEP20)",
  "BSC_BNB",
];

const ETH = [
  "eth",
  "ether",
  "ETH",
  "ERC20",
  "ERC20 ",
  "ERC20 ",
  "Ethereum Classic",
  "Ethereum",
  "Ethereum(ERC20)",
];

const CFX = ["CFX", "Conflux", "CONFLUX", "CFXCORE", "CFX Core"];
const EvaChain = ["EvaChain", "EVC", "EVA", "EVA CHAIN", "CFX Core"];
const CFXeSpace = ["CFXeSpace", "CFXEVM", "CFX_EVM", "CFXE", "CFX eSpace"];
const zkSyncEra = [
  "zkSyncEra",
  "ZKSERA",
  "zkSync Era",
  "ZkSync Era",
  "ZKSYNCERA",
  "ZKERAETH",
  "ZKSYNC",
  "ZKV2",
  "ZKS20",
  "ZkSync ERA",
  "zkSync",
  "ZKsync",
  "ETHZKSYNC",
  "ZKSYNCERA_ETH",
];

const SOL = ["solana", "Solana", "SOLANA", "SOL", "SOL-SOL", "Solana(SOL)"];
const TRX = ["TRX", "TRC20", "trc20", "TRON", "Tron", "Tron(TRC20)"];
const XRP = ["XRP", "Ripple", "Ripple(XRP)", "XRPL"];
const AKT = ["AKT", "Akash", "AKASH"];
const MATIC = ["MATIC", "Polygon", "POLYGON", "Matic network", "MATICPOLY", "Polygon(MATIC)", "Polygon POS"];
const CRO = ["CRO", "CRONOS", "CronosChain", "CRO_Chain", "Crypto", "CRO-CRONOS"];
const EGLD = ["EGLD", "Elrond", "Elrond eGold", "ELROND"];
const NEAR = ["NEAR", "NEARProtocol", "NEAR Protocol", "Near", "NEAR Protocol(NEAR)"];
const KLAY = ["KLAY", "Klaytn", "klaytn", "Klaytn(KLAY)", "KLAYTN"];
const HECO = ["HECO", "HT"];
const RUNE = ["THORChain", "Thorchain", "RUNE", "THORCHAIN"];
const DASH = ["DASH", "Dash", "Digital Cash"];
const ATOM = ["ATOM", "Cosmos", "Cosmos(ATOM)", "COSMOS"];
const FRA = ["FRA", "FRAEVM", "FRA(EVM)"];
const APTOS = ["APTOS", "APT", "Aptos", "APTOS(APT)"];
const ASTAR = ["ASTAR", "Astar", "ASTR", "ASTRC", "ASTAREVM"];
const FIL = ["FIL", "Filecoin", "FILECOIN"];
const ICX = ["ICX", "ICON"];
const INTR = ["INTR", "INTERLAY"];
const ICP = ["ICP", "Internet Computer", "Dfinity", "Internet Computer(ICP)"];
const KSM = ["KSM", "Kusama", "Dfinity"];
const MOVR = ["MOVR", "Moonriver", "Dfinity", "MOONRIVER"];
const KHALA = ["Khala", "PHA"];
const QTUM = ["QTUM", "Qtum", "Quantum"];
const STX = ["STX", "STACKS", "l-Stacks", "stacks", "Stacks"];
const PSL = ["PSL", "Pastel"];
const XTZ = ["XTZ", "Tezos", "TEZOS"];
const ZEC = ["ZEC", "Zerocash", "Zcash"];
const KAS = ["KAS", "KASPA", "Kaspa(KAS)"];
const MINA = ["MINA", "Mina", "mina"];
const TAO = ["TAO", "Bittensor(TAO)", "Bittensor", "BITTENSOR"];
const PLAYA3ULL = ["3ULL", "PLAYA3ULL"];
const OSMO = ["OSMO", "Osmosis", "osmosis"];
const CSPR = ["CSPR", "Casper", "casper"];
const WEMIX = ["WEMIX", "WEMIXMainnet"];
const SC = ["SC", "Siacoin"];
const XCH = ["XCH", "Chia", "Chia(XCH)"];
const DCR = ["DCR", "Decred"];
const NANO = ["NANO", "Nano"];
const RON = ["RON", "Ronin", "RONIN"];
const VET = ["VET", "VeChain", "VeChain(VET)", "vechain", "VECHAIN"];
const EVER = ["EVER", "EVERSCALE", "Ever"];
const KDA = ["KDA", "Kadena", "KDA0", "KDA2"];
const SATOX = ["SATOX", "Satoxcoin(SATOX)"];
const LYX = ["LYX", "LUKSO"];
const POLYX = ["POLYX", "POLYMESH", "Polymesh"];
const ZETA = ["ZETA", "ZetaChain", "ZETACHAIN"];
const HBAR = ["HBAR", "Hedera", "Hedera(HBAR)", "HEDERA"];
const MXC = ["MXC", "mxc", "Layer 3"];
const AR = ["AR", "Arweave"];
const ROSE = ["ROSE", "OASIS"];
const BLAST = ["BLAST", "blast", "BLASTETH", "Blast"];
const ALPH = ["ALPH", "Alephium(ALPH)"];
const MTC = ["MTC", "MetaTime"];
const WAXP = ["WAXP", "WAX", "Wax", "WAX1"];
const DC = ["DC", "DOGECHAIN", "Dogechain(DC)", "DOGEEVM", "DOG20"];
const Starknet = ["Starknet", "Starknet(STARK)", "Starknet network", "STARKNET", "STRKETH", "STRK"];
const LUNC = [
  "LUNC",
  "Terra Classic",
  "TERRA_CLASSIC",
  "TerraClassic",
  "Terra",
  "TERRA",
  "LUNA",
  "Terra(LUNA)",
  "LUNANEW",
];

const CHZ = [
  "CHZ",
  "chz",
  "Chiliz Chain(CHZ)",
  "Chiliz",
  "CHILIZ",
  "ChilizChain",
  "CRC20",
  "CHZ2",
  "CHZ20",
  "CAP20",
  "CHZCHAIN",
  "Chiliz Chain(CHZ2)",
];

const ARBITRUM_NOVA = ["ARBNOVA", "ArbitrumNova", "ARBITRUM NOVA", "ARBINOVA", "Arbitrum Nova"];
const XLM = [
  "XLM",
  "STELLAR",
  "STELLA",
  "Stellar Lumens",
  "StellarLumens",
  "Stellar Network",
  "Stellar",
  "Stellar(XLM)",
];
const XMR = ["XMR", "Monero", "Monero(XMR)"];
const ONE = ["ONE", "Harmony", "HARMONY"];
const AVAIL = ["AVAIL", "AVL"];
const ADA = ["ADA", "ADATOKEN", "CARDANO", "Cardano", "Cardano(ADA)"];
const OPTIMISM = ["OPTIMISM", "Optimism", "ETHOP", "Optimism(OP)", "OP", "OPETH", "OETH", "OPT"];
const ZIL = ["ZIL", "Zilliqa", "Zilliqa(ZIL)", "ZILLIQA"];
const DOT = ["DOT", "Polkadot", "Polkadot(DOT)", "polkadot", "POLKADOT"];
const FTM = ["FTM", "Fantom", "FANTOM", "Fantom(FTM)"];
const ALGO = ["ALGO", "Algorand", "Algorand(ALGO)", "ALGORAND"];
const NRK = ["NRK", "Nordek"];
const BTC = ["BTC", "ORDI", "BRC20", "BRC", "BTCRUNES", "Runes", "RUNES", "BTC Runes", "BTCBRC", "BTC_BRC20"];
const XDC = ["XDC", "XDCNetworkXDC"];
const TON = ["TON", "TONCOIN", "Toncoin(TON)", "Ton", "OPENTON"];
const ONTOLOGY = ["ONTOLOGY", "Ontology", "ONT", "ONG"];
const METIS = ["METIS", "MetisToken", "Metis", "MetisDAO"];
const LTC = ["LTC", "Litecoin", "Litecoin(LTC)"];
const TLOS = ["TLOS", "TELOS", "Telos"];
const XANA = ["XETA", "XANA"];
const BASE = ["BASE", "Base", "BASEEVM", "BASEETH", "ETHBASE", "BASE MAINNET", "BASE-ETH"];
const LSK = ["LSK", "Lisk"];
const CKB = ["CKB", "nervos"];
const MODE = ["MODE", "MODEETH", "ETH_MODE"];
const SXP = ["SXP", "Solar", "SOLAR"];
const OMAX = ["OMAX", "OMAX Chain", "OMAX CHAIN", "OMAX-OMAX CHAIN"];
const SAGA = ["SAGA", "Saga"];
const ETHW = ["ETHW", "ETHPOW", "EthereumPoW", "Ethereum Pow", "ETHPoW", "Ethereum (Proof-of-Work)"];
const KUJI = ["KUJI", "KUJIRA"];
const ARBITRUM = [
  "ARBITRUM",
  "Arbitrum",
  "arbitrum",
  "ARBITRUMONE",
  "ARBEVM",
  "ArbitrumOne",
  "Arbitrum One",
  "Arbitrum one",
  "ARBITRUM ONE",
  "ARBI",
  "ARB",
  "ETHARB",
  "ARC20",
  "Arbitrum One(ARB)",
];
const AVAX_C = [
  "AVAXC",
  "AVAX_C",
  "AVAX-C",
  "AVAXCCHAIN",
  "AVAX_CCHAIN",
  "AVAX C-Chain",
  "AVAX CCHAIN",
  "Avalanche C-Chain",
  "avalanche C chain",
  "AVALANCHE",
  "CAVAX",
  "AVA_C",
  "CCHAIN",
  "CCHAINERC20",
  "C-Chain",
  "C-CHAIN",
  "C Chain",
  "Avalanche C Chain(AVAX CCHAIN)",
];
const AVAX_X = [
  "AVAX",
  "XAVAX",
  "AVAX_XCHAIN",
  "AVAX-X",
  "Avalanche X-Chain",
  "X-Chain",
  "XCHAIN",
  "Avalanche X Chain(AVAX XCHAIN)",
];
const ACA = ["ACA", "Acala", "AcalaToken", "ACALA"];
const FLR = ["FLR", "FLARE", "Flare"];
const GLMR = ["GLMR", "Moonbeam", "MOONBEAM"];
const GMMT = ["GMMT", "GiantMammoth"];
const XPR = ["XPR", "PROTON", "Proton", "XPR Network"];
const DOGE = ["DOGE", "Dogecoin", "Dogecoin(DOGE)", "DOGECOIN", "dogecoin", "dogechain"];
const LINEA = ["LINEA", "LINEAETH", "LINEA-ETH", "Linea", "ETHLINEA"];
const BounceBit = ["BounceBit", "BOUNCEBIT", "BB"];
const ENJ = ["ENJ", "Enjin", "ENJIN", "enjin", "Enjin Relay Chain"];
const MANTLE = ["MANTLE", "Mantle", "Mantle(MNT)", "MNT"];
const INJ = ["INJ", "INJECTIVE", "Injective"];
const SYS = ["SYS", "SYSCOIN UTXO", "Syscoin UTXO"];
const SYSNEVM = ["SYSNEVM", "SYSCOIN NEVM", "SyscoinNEVM", "Syscoin NEVM"];
const NTRN = ["NTRN", "NEUTRON", "Neutron"];
const TIA = ["TIA", "Celestia", "CELESTIA", "Celestia(TIA)"];
const NEO = ["NEO"];
const NEON3 = ["NEON3", "NEO N3", "NEO3", "N3", "GAS"];
const QUBIC = ["QUBIC", "qubic"];
const VENOM = ["VENOM", "Venom"];
const MTRG = ["MTRG", "MTR", "METER", "Meter(MTRG)"];
const SUI = ["SUI", "Sui"];
const CORE = ["CORE", "CoreDAO", "Core Dao", "COREDAO"];
const DIVI = ["DIVI", "Divi"];
const KAVA = ["KAVA", "kava"];
const KLS = ["KLS", "Karlsen"];
const IRON = ["IRON", "ironfish", "IRONFISH"];
const DIS = ["DIS", "DISCHAIN", "DisChain"];
const JOYSTREAM = ["JOYSTREAM", "joystream", "JOY"];
const KLV = ["KLV", "klv", "Klever"];
const KUB = ["KUB", "BitkubChain", "BITKUB"];
const OKT = ["OKT", "OKTC", "OKT CHAIN"];
const IOST = ["IOST", "Iost chain"];
const IOTX = ["IOTX", "IoTeX", "IOTEX"];
const IOTA = ["IOTA", "MIOTA"];
const RVN = ["RVN", "Ravencoin", "Ravencoin(RVN)", "Raven", "RAVENCOIN"];
const DYM = ["DYM", "Dymension", "DYMENSION", "Dymension network", "Dymension(DYM)"];
const OMN = ["OMN", "OMEGA", "Omega Main Network", "Omega Chain", "Omega Network(OMN)"];
const BAHAMUT = ["BAHAMUT", "Bahamut", "Bahamut (BHRC20)", "Mainnet-BHRC20", "FTN"];
const XEM = ["XEM", "NEM", "New Economy Movement"];
const RXD = ["RXD", "RADIANT", "Radiant"];
const SEI = ["SEI", "Sei"];
const SCR = ["SCR", "SCROLL", "Scroll", "SCROLLETH", "scroll"];
const MANTA = [
  "MANTA",
  "Manta",
  "Manta Network",
  "MA",
  "MANTAETH",
  "METH",
  "MantaNetWork",
  "MANTA-ETH",
];
const MERLIN = [
  "MERLIN",
  "MERLBTC",
  "MERLINCHAIN",
  "MERLIN Network",
  "Merlin",
  "merlin",
  "BTCMERLIN",
];

const FRACTAL = ["FRACTAL", "FRACTALBIT", "fractal", "FB"];
const BCH = ["BCH", "BCHN", "BitcoinCash", "Bitcoin Cash", "Bitcoin Cash(BCH)", "Bitcoin ABC"];
const BSV = ["BSV", "Bitcoin SV", "Bitcoin SV(BSV)", "BCHSV"];
const KRO = ["KRO", "KROMA", "KROETH"];

const NETWORKS_MAP = {
  ...map(ETH, NETWORKS.ETH),
  ...map(BSC, NETWORKS.BSC),
  ...map(SOL, NETWORKS.SOL),
  ...map(TRX, NETWORKS.TRX),
  ...map(XRP, NETWORKS.XRP),
  ...map(CHZ, NETWORKS.CHZ),
  ...map(MATIC, NETWORKS.MATIC),
  ...map(CRO, NETWORKS.CRO),
  ...map(EGLD, NETWORKS.EGLD),
  ...map(NEAR, NETWORKS.NEAR),
  ...map(KLAY, NETWORKS.KLAY),
  ...map(ARBITRUM, NETWORKS.ARBITRUM),
  ...map(ARBITRUM_NOVA, NETWORKS.ARBITRUM_NOVA),
  ...map(AVAX_C, NETWORKS.AVAX_C),
  ...map(AVAX_X, NETWORKS.AVAX_X),
  ...map(HECO, NETWORKS.HECO),
  ...map(RUNE, NETWORKS.RUNE),
  ...map(XLM, NETWORKS.XLM),
  ...map(XMR, NETWORKS.XMR),
  ...map(ADA, NETWORKS.ADA),
  ...map(OPTIMISM, NETWORKS.OPTIMISM),
  ...map(ZIL, NETWORKS.ZIL),
  ...map(DOT, NETWORKS.DOT),
  ...map(FTM, NETWORKS.FTM),
  ...map(ALGO, NETWORKS.ALGO),
  ...map(BTC, NETWORKS.BTC),
  ...map(XDC, NETWORKS.XDC),
  ...map(TON, NETWORKS.TON),
  ...map(ONTOLOGY, NETWORKS.ONTOLOGY),
  ...map(METIS, NETWORKS.METIS),
  ...map(ACA, NETWORKS.ACA),
  ...map(FLR, NETWORKS.FLR),
  ...map(ONE, NETWORKS.ONE),
  ...map(LTC, NETWORKS.LTC),
  ...map(NRK, NETWORKS.NRK),
  ...map(TLOS, NETWORKS.TLOS),
  ...map(AKT, NETWORKS.AKT),
  ...map(GLMR, NETWORKS.GLMR),
  ...map(GMMT, NETWORKS.GMMT),
  ...map(XPR, NETWORKS.XPR),
  ...map(APTOS, NETWORKS.APTOS),
  ...map(ASTAR, NETWORKS.ASTAR),
  ...map(ATOM, NETWORKS.ATOM),
  ...map(DASH, NETWORKS.DASH),
  ...map(FIL, NETWORKS.FIL),
  ...map(ICX, NETWORKS.ICX),
  ...map(INTR, NETWORKS.INTR),
  ...map(ICP, NETWORKS.ICP),
  ...map(KSM, NETWORKS.KSM),
  ...map(MOVR, NETWORKS.MOVR),
  ...map(KHALA, NETWORKS.KHALA),
  ...map(QTUM, NETWORKS.QTUM),
  ...map(STX, NETWORKS.STX),
  ...map(XTZ, NETWORKS.XTZ),
  ...map(ZEC, NETWORKS.ZEC),
  ...map(KAS, NETWORKS.KAS),
  ...map(MINA, NETWORKS.MINA),
  ...map(TAO, NETWORKS.TAO),
  ...map(FRA, NETWORKS.FRA),
  ...map(XANA, NETWORKS.XANA),
  ...map(BASE, NETWORKS.BASE),
  ...map(PLAYA3ULL, NETWORKS.PLAYA3ULL),
  ...map(OSMO, NETWORKS.OSMO),
  ...map(CSPR, NETWORKS.CSPR),
  ...map(WEMIX, NETWORKS.WEMIX),
  ...map(SC, NETWORKS.SC),
  ...map(XCH, NETWORKS.XCH),
  ...map(DCR, NETWORKS.DCR),
  ...map(NANO, NETWORKS.NANO),
  ...map(RON, NETWORKS.RON),
  ...map(VET, NETWORKS.VET),
  ...map(EVER, NETWORKS.EVER),
  ...map(KDA, NETWORKS.KDA),
  ...map(LSK, NETWORKS.LSK),
  ...map(SATOX, NETWORKS.SATOX),
  ...map(LYX, NETWORKS.LYX),
  ...map(POLYX, NETWORKS.POLYX),
  ...map(ZETA, NETWORKS.ZETA),
  ...map(HBAR, NETWORKS.HBAR),
  ...map(CKB, NETWORKS.CKB),
  ...map(MXC, NETWORKS.MXC),
  ...map(MANTA, NETWORKS.MANTA),
  ...map(CFX, NETWORKS.CFX),
  ...map(CFXeSpace, NETWORKS.CFXeSpace),
  ...map(zkSyncEra, NETWORKS.zkSyncEra),
  ...map(EvaChain, NETWORKS.EvaChain),
  ...map(AR, NETWORKS.AR),
  ...map(Starknet, NETWORKS.Starknet),
  ...map(ROSE, NETWORKS.ROSE),
  ...map(BLAST, NETWORKS.BLAST),
  ...map(ALPH, NETWORKS.ALPH),
  ...map(LUNC, NETWORKS.LUNC),
  ...map(DOGE, NETWORKS.DOGE),
  ...map(MERLIN, NETWORKS.MERLIN),
  ...map(MODE, NETWORKS.MODE),
  ...map(LINEA, NETWORKS.LINEA),
  ...map(BounceBit, NETWORKS.BounceBit),
  ...map(ENJ, NETWORKS.ENJ),
  ...map(MANTLE, NETWORKS.MANTLE),
  ...map(INJ, NETWORKS.INJ),
  ...map(SYS, NETWORKS.SYS),
  ...map(SYSNEVM, NETWORKS.SYSNEVM),
  ...map(NTRN, NETWORKS.NTRN),
  ...map(TIA, NETWORKS.TIA),
  ...map(NEO, NETWORKS.NEO),
  ...map(NEON3, NETWORKS.NEON3),
  ...map(QUBIC, NETWORKS.QUBIC),
  ...map(VENOM, NETWORKS.VENOM),
  ...map(MTRG, NETWORKS.MTRG),
  ...map(SUI, NETWORKS.SUI),
  ...map(CORE, NETWORKS.CORE),
  ...map(DIVI, NETWORKS.DIVI),
  ...map(KAVA, NETWORKS.KAVA),
  ...map(BAHAMUT, NETWORKS.BAHAMUT),
  ...map(IRON, NETWORKS.IRON),
  ...map(PSL, NETWORKS.PSL),
  ...map(OMN, NETWORKS.OMN),
  ...map(KLS, NETWORKS.KLS),
  ...map(DYM, NETWORKS.DYM),
  ...map(DIS, NETWORKS.DIS),
  ...map(SXP, NETWORKS.SXP),
  ...map(OMAX, NETWORKS.OMAX),
  ...map(RVN, NETWORKS.RVN),
  ...map(JOYSTREAM, NETWORKS.JOYSTREAM),
  ...map(KLV, NETWORKS.KLV),
  ...map(KUB, NETWORKS.KUB),
  ...map(OKT, NETWORKS.OKT),
  ...map(IOST, NETWORKS.IOST),
  ...map(IOTX, NETWORKS.IOTX),
  ...map(IOTA, NETWORKS.IOTA),
  ...map(XEM, NETWORKS.XEM),
  ...map(RXD, NETWORKS.RXD),
  ...map(WAXP, NETWORKS.WAXP),
  ...map(AVAIL, NETWORKS.AVAIL),
  ...map(SEI, NETWORKS.SEI),
  ...map(DC, NETWORKS.DC),
  ...map(MTC, NETWORKS.MTC),
  ...map(FRACTAL, NETWORKS.FRACTAL),
  ...map(ETHW, NETWORKS.ETHW),
  ...map(KUJI, NETWORKS.KUJI),
  ...map(SAGA, NETWORKS.SAGA),
  ...map(BCH, NETWORKS.BCH),
  ...map(BSV, NETWORKS.BSV),
  ...map(SCR, NETWORKS.SCR),
  ...map(KRO, NETWORKS.KRO),
};

function map(list, network) {
  return list.reduce((res, val) => {
    res[val] = network;
    return res;
  }, {});
}

const DEPOSIT_TIMES = {
  BITCI: "~1-2 h.",
  [NETWORKS.ETH]: "~10-15 m.",
  [NETWORKS.MATIC]: "~10-15 m.",
  [NETWORKS.ALPH]: "~1h",
  [NETWORKS.XMR]: "~1h",
  [NETWORKS.BSC]: "~5 m.",
  [NETWORKS.AVAX_C]: "~5 m.",
  [NETWORKS.TRX]: "~5 m.",
  [NETWORKS.SOL]: "~5 m.",
  [NETWORKS.XRP]: "~5 m.",
  [NETWORKS.ARBITRUM]: "~5 m.",
  [NETWORKS.FTM]: "~5 m.",
  [NETWORKS.FLR]: "~5 m.",
  [NETWORKS.NRK]: "~5 m.",
  [NETWORKS.GMMT]: "~5 m.",
  [NETWORKS.ROSE]: "~5 m.",
};

module.exports = { NETWORKS, NETWORKS_MAP, DEPOSIT_TIMES };
